export const APP_PORTFOLIO_SOURCE = {
  InstallationImport: 'InstallationImport',
  WdacImport: 'WdacImport',
  TelemetryOnly: 'TelemetryOnly',
};

// How an app version came to be in the portfolio: through either kind of import, or through
// telemetry alone when no import identified it.
const APP_PORTFOLIO_SOURCE_MAPPING = [
  { value: APP_PORTFOLIO_SOURCE.InstallationImport, label: 'Installation Import' },
  { value: APP_PORTFOLIO_SOURCE.WdacImport, label: 'WDAC Import' },
  { value: APP_PORTFOLIO_SOURCE.TelemetryOnly, label: 'Telemetry only' },
];

export const getAppPortfolioSourceLabel = value =>
  APP_PORTFOLIO_SOURCE_MAPPING.find(item => item.value === value)?.label ?? '';

export const getAppPortfolioSourceOptions = () =>
  APP_PORTFOLIO_SOURCE_MAPPING.map(({ value, label }) => ({ value, label }));
